import { useQuery } from 'src/graphql';
import { EXTERNAL_USERS_ACTIVE_SAQ_JOBS } from 'src/graphql/dashboard/query';

export default (limit = 18, offset = 0) =>
  useQuery(EXTERNAL_USERS_ACTIVE_SAQ_JOBS, {
    variables: {limit, offset},
    fetchPolicy: 'network-only',
  });
